import {
  ConsequenceItem,
  ProbabilityOfFailureItem,
  RiskLevelItem,
  RiskMatrix,
  RiskMatrixCell,
} from 'src/app/admin/pages/risk-setup/types/risk-config.model'
import { IReasons } from 'src/app/template/critical-area-window/critical-area.model'

export const riskMatrixUtils = {
  getHighestReason(
    reasons: IReasons[],
    riskMatrix: RiskMatrix,
    riskLevels: RiskLevelItem[],
    probabilitiesOfFailure: ProbabilityOfFailureItem[],
    consequences: ConsequenceItem[],
  ): IReasons | null {
    const validReasons = reasons.filter((r) => r !== null && r !== undefined && r.active)

    if (validReasons.length === 0) {
      return null
    }

    const highestRiskReason = [...validReasons].sort(
      (a, b) =>
        this.getRiskOrder(b, riskMatrix, riskLevels, probabilitiesOfFailure, consequences) -
        this.getRiskOrder(a, riskMatrix, riskLevels, probabilitiesOfFailure, consequences),
    )[0]

    return highestRiskReason
  },

  getRiskOrder(
    reason: IReasons | null,
    riskMatrix: RiskMatrix,
    riskLevels: RiskLevelItem[],
    probabilitiesOfFailure: ProbabilityOfFailureItem[],
    consequences: ConsequenceItem[],
  ): number {
    if (!reason) {
      return -1
    }

    const cell = this.getRiskMatrixCell(reason, riskMatrix)
    if (!cell) return -1

    const riskLevel = riskLevels.find((rl) => rl.id === cell.riskLevelId)
    return riskLevel?.order ?? -1
  },

  getRiskMatrixCell(reason: IReasons | null, riskMatrix: RiskMatrix): RiskMatrixCell | null {
    if (!reason) {
      return null
    }

    return (
      riskMatrix.cells.find(
        (cell) =>
          cell.probabilityOfFailureId === reason.probabilityOfFailureId &&
          cell.consequenceId === reason.consequenceId,
      ) || null
    )
  },
}

export const { getHighestReason, getRiskOrder, getRiskMatrixCell } = riskMatrixUtils

export default riskMatrixUtils
